module.exports = __webpack_public_path__ + "1_0_58/img/link.6e4a0216.svg";